module.exports = __webpack_public_path__ + "media/chevron.f819d2d2.svg";